export function init($name = '') {
    const parent = $($name);

    const contents = $name + '-contents';
    const logos = $name + '-nav';

    if (!parent.length || !$(contents).length || !$(logos).length) {
        return;
    }

    let length = $(contents).find(contents + '-item').length;

    if ($(contents).length && $(logos).length) {
        $(contents).slick({
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            variableWidth: false,
            centerMode: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            swipe: true,
            swipeToSlide: true,
            asNavFor: logos,
            pauseOnHover: false,
            autoplaySpeed: 8000
        });

        let slidesToShow = 7;

        if (length < 7) {
            slidesToShow = length;
        }

        $(logos).slick({
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: false,
            centerMode: true,
            swipe: true,
            swipeToSlide: true,
            focusOnSelect: true,
            adaptiveHeight: false,
            slidesToShow: ($(window).width() >= 900 ? slidesToShow : 1),
            slidesToScroll: 1,
            asNavFor: contents,
            vertical: ($(window).width() >= 900),
            variableWidth: ($(window).width() < 900),
            pauseOnHover: false,
            autoplaySpeed: 8000
        });

        // $(contents)[0].slick.slickGoTo(Math.floor(length / 2));
    }
}